import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _querySellPlanGoodss(
  {
    sellPlanId, page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/sell-plan-goodss`,
    method: 'get',
    params: {
      sellPlanId,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _querySellPlanGoods(sellPlanGoodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/sell-plan-goodss/${sellPlanGoodsId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  sellPlanId
 * @param  goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addSellPlanGoods(
  {
    sellPlanId,
    goodsId,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/sell-plan-goodss`,
    method: 'post',
    data: {
      sellPlanId,
      goodsId,
    },
  });
}

/**
 * 更新
 * @param sellPlanGoodsId
 * @param  sellPlanId
 * @param  goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateSellPlanGoods(sellPlanGoodsId, {
  sellPlanId,
  goodsId,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/sell-plan-goodss/${sellPlanGoodsId}`,
    method: 'patch',
    data: {
      sellPlanId,
      goodsId,
    },
  });
}

/**
 * 删除
 * @param sellPlanGoodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteSellPlanGoods(sellPlanGoodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/sell-plan-goodss/${sellPlanGoodsId}`,
    method: 'delete',
  });
}

export default {};
